import { Chip } from "./Chip";

/**
 * Awaiting approval blocks every session to the resource, so the reason is
 * stated in the row rather than hidden in a tooltip. Verified stays quiet.
 */
const AWAITING_APPROVAL = "AwaitingApproval";

export function HostIdentityBadge({ state }: { state: string | null }) {
  if (state === AWAITING_APPROVAL) {
    return <Chip variant="warning">Sessions refused</Chip>;
  }

  return null;
}
